
import SwiperSlider from './swiper-slider';

export default class SwiperTabs {

  constructor(parent, id) {
    this.parent = parent;
    this.id = id;
    this.isSliding = false;
    this.init();
  }

  init() {
    const selector = `[data-swiper-tab-id="${this.id}"]`;
    const node = document.querySelector(selector);
    const activeBg = node.querySelector('[data-active-bg]');
    this.node = new SwiperSlider(node);
    this.activeBg = new ActiveBg(activeBg, node.swiper);
  }

  get instance() {
    return this.node;
  }

  bindSliders() {
    this.slideChangeTransitionStart(this.parent.swiper, this.node.swiper);
    this.slideChangeTransitionEnd(this.parent.swiper, this.node.swiper);

    this.tabsChangeTransitionStart(this.parent.swiper, this.node.swiper);
    this.tabsChangeTransitionEnd(this.parent.swiper, this.node.swiper);

    this.node.swiper.slides[0].classList.add('_tabs-active');
  }

  slideChangeTransitionStart(slider, controls) {
    slider.on('slideChangeTransitionStart', (swiper) => {
      this.isSliding = true;
      controls.slideTo(swiper.realIndex);
      this.activeBg.setActive();
    });
  }

  slideChangeTransitionEnd(slider, controls) {
    slider.on('slideChangeTransitionEnd', () => {
      this.isSliding = false;
    });
  }

  tabsChangeTransitionStart(slider, controls) {
    controls.on('slideChangeTransitionStart', (swiper) => {
      controls.slides.forEach(element => {
        element.classList.remove('_tabs-active');
      });
      if (!this.isSliding) {
        slider.slideTo(swiper.activeIndex + swiper.slides.length);
        this.activeBg.setActive();
      }
    })
  }

  tabsChangeTransitionEnd(slider, controls) {
    controls.on('slideChangeTransitionEnd', (swiper) => {
      this.isSliding = false;
      controls.slides[swiper.realIndex].classList.add('_tabs-active');
    });
  }
}

export class ActiveBg {

  constructor(node, slider) {
    this.node = node;
    this.slider = slider;
    this.setActive();
  }

  setActive(index) {
    const currentSlide = this.slider.slides[this.slider.realIndex];
    const positionLeft = currentSlide.offsetLeft;
    const width = currentSlide.clientWidth;

    this.node.style.left = positionLeft + 'px';
    this.node.style.width = width + 'px';
  }
}
